import {Box, createStyles, Grid, IconButton, makeStyles, Theme} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../const/i18nNamespaces';
import {desktop, mobile} from '../../../const/sizes';
import AppLogo from '../AppLogo/AppLogo';
import {Logo} from '../../../assets';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        topBar: {
            padding: mobile.contentLargerSpacing,
            backgroundColor: 'white',
            alignItems: 'center',
            flexDirection: 'row',
            minHeight: 64,
            boxShadow:
                '0px 2px 4px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.04)',
        },
        cancel: {
            width: 20,
            height: 20,
        },
        title: {
            fontWeight: 'bold',
            textAlign: 'center',
        },
        rightWrapper: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        [theme.breakpoints.up('md')]: {
            topBar: {
                padding: `0 ${desktop.contentLargerSpacing}`,
            },
        },
    }),
);

type EmptyTopBarProps = {
    onCancel?: () => void;
    title?: string;
};

const EmptyTopBar = ({onCancel, title}: EmptyTopBarProps) => {
    const classes = useStyles();
    const {t} = useTranslation(i18nNamespaces.COMMON);

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className={classes.topBar}
        >
            <Box style={{flex: 1}}>
                <AppLogo />
            </Box>
            <Box style={{flex: 1}} className={classes.title}>
                {title ? title : ''}
            </Box>
            <Box style={{flex: 1}} className={classes.rightWrapper}>
                {onCancel && (
                    <IconButton aria-label={t('close')} onClick={onCancel}>
                        <Close className={classes.cancel} />
                    </IconButton>
                )}
            </Box>
        </Grid>
    );
};

export default EmptyTopBar;
